import ServiceWorksPlanning from "components/modal/serviceWorksPlanning";
import { ServiceWorkTooltipContent } from "components/planning/serviceWorksTooltipContent";
import { useMouseEvents } from "components/shared/tooltipFME";
import { dateTimeToView } from "helpers/date";
import { getServiceWorkType } from "helpers/serviceWorks";
import React, { useMemo } from "react";

export default function ServiceWork(props) {
    const { serviceWorkData } = props.item;
    const serviceWorkContent = useMemo(
        () => <ServiceWorkTooltipContent serviceWork={serviceWorkData} />,
        [serviceWorkData],
    );
    const period = `${dateTimeToView(serviceWorkData.startDate, "DD.MM HH:mm")} – ${dateTimeToView(
        serviceWorkData.endDate,
        "DD.MM HH:mm",
    )}`;
    const description = [getServiceWorkType(serviceWorkData), serviceWorkData.comment].filter(Boolean).join(": ");
    const mouseEvents = useMouseEvents({
        overlay: serviceWorkContent,
        timeout: 300,
        className: "car-planning__service-work-tooltip",
    });

    return (
        <div
            className="car-planning__service-work-content"
            {...mouseEvents}
            onClick={(event) => {
                event.stopPropagation();
                props.options.modal({
                    name: "default",
                    title: "Сервисные работы",
                    windowMod: "wide",
                    CustomBody: ServiceWorksPlanning,
                    bodyData: { serviceWorks: [serviceWorkData], showAll: true },
                });
            }}
        >
            <span className="car-planning__service-work-period">{period}</span>
            {description && <span className="car-planning__service-work-description">{description}</span>}
        </div>
    );
}
